import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import Header from './components/Header/Header'
import Home from './components/Home/Home'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Header />
    <Home />
  </React.StrictMode>
)

reportWebVitals()
